module.exports = __webpack_public_path__ + "static/media/LVS_04.23e0b107.jpeg";